$.fn.showLoader = function (o) {
    /// <summary>Shows a loading panel over the element</summary>
    /// <param name="o" type="Object">The loader options</param>
    /// <returns type="$">Returns the JQuery element(s)</returns>

    let timeout;
    this.each((i, el) => {
        let options = o ? cafm.util.clone(o) : {};
        options.target = $(el);        
        if (options.timeout) {
            timeout = cafm.util.callFunctionAsync({
                func() {
                    cafm.lp.showLoader(options);
                },
                timeout: options.timeout
            })
        }
        else {
            cafm.lp.showLoader(options);
        }
    });
    return isDefined(timeout) ? timeout : this;
}

$.fn.hideLoader = function (o) {
    /// <summary>Hides a loading panel</summary>
    /// <param name="o" type="Object">The loader options</param>
    /// <returns type="$">Returns the JQuery element(s)</returns>

    this.each((i, el) => {
        let options = o ? cafm.util.clone(o) : {};
        options.target = $(el);
        cafm.lp.hideLoader(options);
    });

    return this;
}

$.fn.resetLoaderButtons = function () {
    /// <summary>Resets buttons changed by a loader</summary>
    /// <returns type="$">Returns the JQuery element(s)</returns>

    this.each(function () {
        var o = {
            target: $(this)
        };
        cafm.lp.resetLoaderButtons(o);
    });

    return this;
}

cafm.lp = {
    showLoader: function (o) {
        /// <summary>Shows a loading panel on the target element passed in o.target</summary>
        /// <param name="o" type="Object">The loader options</param>

        let ltn = o.target[0].tagName.toLowerCase();
        o.buttonIsTarget = o.target ? ['input', 'button'].indexOf(ltn) > -1 : false;

        if (o.buttonIsTarget) {

            o.target.prop('disabled', true);
        }
        else {

            o.bodyIsTarget = o.target ? ltn === 'body' : false;
        }

        if (!o.forceLoader && $('.clp', o.target).length) {

            if (o.text) $('.clpTxt', o.target).text(o.text);
            return;
        }

        let clpCss;
        if(o.bodyIsTarget){

            clpCss = 'clp bodyClp';
        }
        else {

            clpCss = 'clp';
        }

        let lp = $('<div />', {
            'class': clpCss
        });
        $('<div />', {
            'class': 'clpBg'
        }).appendTo(lp);
        let i = $('<img />', {
            'class': 'clpImg'
        }).appendTo(lp);

        if (!(o.buttonIsTarget || o.isInPlaceLoader)) {

            i.attr('src', cafm.url.get('Content/Themes/Kendo/Silver/loading-image.gif'));
            $('<span />', {
                'class': 'clpTxt',
                text: !o.text ? cafm.res.str.TextLoading : o.text
            }).appendTo(lp);
        }
        else {

            i.attr('src', cafm.url.get('Content/Themes/Kendo/Silver/loading.gif'));
        }

        lp.appendTo(body);

        let ph, mt;
        if (!(o.buttonIsTarget || o.isInPlaceLoader)) {

            o.target.find('.k-loading-mask').hide(); // hide any kendo loaders already there
            
            let determineTopMargin = function () {

                let heightProps;

                if (o.target) {

                    o.target.addClass('loadTarget');

                    heightProps = cafm.dom.getElementVisibleHeightProps(o.target);

                    ph = heightProps.visibleHeight;
                    if (!ph) ph = 100;
                }
                else {

                    heightProps = cafm.dom.getElementVisibleHeightProps(body);
                    ph = heightProps.visibleHeight;
                    if (!ph) ph = 100;
                }

                mt = parseInt(ph / 2);

                if (heightProps.visibleOffsetTop) mt += heightProps.visibleOffsetTop;

                $('.clpImg,.clpTxt', lp).css('top', mt);
            }

            determineTopMargin();

            if (o.target) {

                lp.prependTo(o.target);
            }
            else {

                lp.appendTo(body);
            }
        }
        else if (o.isInPlaceLoader) {

            let existing;
            if ((existing = o.target.parent().find('.inplace-loader')).length) existing.remove();

            o.target.parent().addClass('inplace-loader-parent');
            o.target.hide();
            i.insertAfter(o.target);
            lp = i;
            lp.addClass('inplace-loader');
        }
        else {

            lp.addClass('btnLoad');
            lp.css('position', 'absolute');
            lp.css('display', 'block');
            lp.css('left', '0');
            lp.css('top', '0');
            o.target.addClass('btn-load-target');
            lp.appendTo(o.target);

            let btn = o.target;
            btn.css('visibility', 'hidden');

            let par = btn.parent();
            if (par.hasClass('cTb')) {
                par.children().filter(':visible').attr('disabled', 'true').attr('disabledByLoading', true);
            }
            else if (par.hasClass('action-buttons')) {
                par.children().filter(':visible').attr('disabled', 'true').attr('disabledByLoading', true);
            }
        }

        lp.data('loaderOptions', o);
        o.target.data('loader', lp);
        lp.fadeIn(250);
    },
    hideLoader: function (e) {
        /// <summary>Hides a loading panel in the target element passed in o.target</summary>

        let t = e.target;
        if (!t)
            t = body;

        let clp = t.data('loader');
        if (clp) {

            clp.hide();

            let o = clp.data('loaderOptions');
            if (!o) o = {};
            if (o.isInPlaceLoader) {
                o.target.show();
                o.target.parent().removeClass('inplace-loader-parent');
            }
            
            t.removeClass('loadTarget').removeClass('btn-load-target').removeData('loader');

            setTimeout(() => {
                clp.remove();
                if (o.buttonIsTarget && !e.success) {
                    let btn = o.target,
                        par = btn.parent();
                    btn.prop('disabled', false);
                    btn.css('visibility', 'visible');
                    if (par.hasClass('cTb')) {
                        par.find('[disabledByLoading]').removeAttr('disabled').removeAttr('disabledByLoading');
                    }
                    else if (par.hasClass('action-buttons')) {
                        par.find('[disabledByLoading]').removeAttr('disabled').removeAttr('disabledByLoading');
                    }
                }
            }, o.timeout || 250);
        }
    },
    resetLoaderButtons: function (e) {

        let t = e.target;        
        t.find('.btn').css('visibility', 'visible').removeAttr('disabledbyloading').prop('disabled', false);
    }
}